import React, {  Component } from 'react';
import MasterLayout from './component/layout/MasterLayout';
import  ErrorCatch  from "./component/errorBoundary/Error";


class App extends Component {

  render() {
  

        return (
        //  <ErrorCatch>
           <MasterLayout/>
        //  </ErrorCatch>

        )
    }
  
}

export default App;
  